const giantNoteList = require('./giant')

module.exports = [
  ...giantNoteList,
  {
    text: `Людям не хватает проницательности и большинство не заметит знамения даже если оно подойдёт и поцелует их в губы. Штормовые великаны же настроены на окружающее и прозревают грядущее.`,
    author: `Эльминстер`,
  },
]
